export default function HeroSection() {
  return (
    <section
      className="relative flex flex-col items-center justify-center w-full bg-background-50"
      style={{ paddingTop: '120px', paddingBottom: '160px' }}
      aria-label="Company title"
    >
      <span
        className="font-label text-xs tracking-[0.18em] uppercase text-foreground-500 mb-6"
      >
        Software Engineering
      </span>
      <h1
        className="font-heading text-[4.5rem] md:text-[6rem] lg:text-[7.5rem] font-light tracking-tight text-foreground-950 leading-none text-center"
      >
        Shilanza IT AB
      </h1>
    </section>
  );
}